import { useContext, useState, useEffect, FormEvent } from 'react';
import { useLocation } from 'react-router-dom';
import { buscarPlanoAcao } from '../../services/desafios';
import { ModalEstadoContext } from '../../contexts/ModalEstado';
import { listPlanoAcao } from '../../interfaces/desafios';
import { toast } from 'react-toastify';
import { Button, Loader } from '../Styles';
import { listarMembrosProjeto } from '../../services/projetos';
import { membrosResponsaveis } from '../../interfaces/desafios';
import FiltrosDefault from '../FiltrosDefault';
import NenhumResultadoEncontrado from '../NenhumResultadoEncontrato';
import LoadingBarra from '../LoadingBarra';
import avatarDefault from "../../assets/img/avatarDefault.png";
import DivSituacao from '../DivSituacao';
import ModalPlanoAcao from '../ModalPlanoAcao';
import maisFiltrosImg from '../../assets/img/maisFiltros.png'

function PlanoAcao() {
  const { atualizarInformacoes, modal, modalExibir } = useContext(ModalEstadoContext);

  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)

  const idProjeto = paramsUrl.get("idProjeto");
  const grupo = paramsUrl.get("grupo");

  const usuarioExterno = localStorage.getItem("usuarioProjeto")

  const [processando, setProcessando] = useState(false);
  const [nenhumResultado, setNenhumResultado] = useState(false);
  const [planoAcoes, setPlanoAcoes] = useState<listPlanoAcao[]>([]);
  const [titulo, setTitulo] = useState("");
  const [situacao, setSituacao] = useState("");
  const [maisFiltros, setMaisFiltros] = useState(false);
  const [responsaveis, setResponsaveis] = useState<membrosResponsaveis[]>([]);
  const [responsavel, setResponsavel] = useState("");
  const [planoAcaoSelecionado, setPlanoAcaoSelecionado] = useState<listPlanoAcao>();

  const filtrarPlanoAcao = async (e: FormEvent) => {
    e.preventDefault()
    setProcessando(true);
    if (!idProjeto) return toast.error("Projeto não encontrado.")
    try {
      const params = {
        titulo,
        situacao,
        idResponsavel: responsavel,
        idProjeto
      }
      const response = await buscarPlanoAcao(params);
      if (response.status === 200 && response.data.length > 0) {
        setNenhumResultado(false);
        setProcessando(false);
        setMaisFiltros(false);
        return setPlanoAcoes(response.data);
      }

      setNenhumResultado(true);
      setProcessando(false);
    } catch (error) {
      toast.error('Erro ao listar Plano de Ação:')
      setNenhumResultado(true);
      setProcessando(false);
    }
  };

  const abrirModalEditarPlanoAcao = () => {
    return modalExibir("ModalPlanoAcao")
  }

  const abrirModalNovoPlanoAcao = () => {
    setPlanoAcaoSelecionado(undefined);
    return modalExibir("ModalPlanoAcao")
  };

  useEffect(() => {
    const listarPlanoAcao = async () => {
      setProcessando(true);
      if (!idProjeto) return toast.error("Projeto não encontrado.")
      try {
        const params = {
          titulo,
          situacao,
          idResponsavel: "",
          idProjeto
        }
        const response = await buscarPlanoAcao(params);
        if (response.data && response.data.length > 0) {
          setPlanoAcoes(response.data);
          setNenhumResultado(false);
        } else {
          setNenhumResultado(true);
        }
        return setProcessando(false);
      } catch (error) {
        toast.error('Erro ao listar Plano de Ação.')
        setNenhumResultado(true);
        setProcessando(false);
      }
    };

    listarPlanoAcao();
  }, [atualizarInformacoes, idProjeto]);

  useEffect(() => {
    const listarMembrosResponsaveis = async () => {
      if (!idProjeto) return toast.error("Não foi possivel encontrar o projeto.")

      try {
        const idProjetoEncoded = encodeURIComponent(idProjeto)
        const resposta = await listarMembrosProjeto(idProjetoEncoded);
        if (resposta.status === 200) {
          return setResponsaveis(resposta.data)
        }

      } catch (error) {
        toast.error("Erro ao listar todos os membros do Projeto.");
      }
    };
    listarMembrosResponsaveis()

  }, [idProjeto])

  return (
    (grupo === "Gestão Financeira" || grupo === "Gestão de Pessoas" || grupo === "Outros") ? (
      <div id='paginaContainer'>
        {processando && <LoadingBarra />}
        <FiltrosDefault termo={titulo} situacao={situacao} placeholder='Pesquise pelo Titulo da Ação' tipo={!usuarioExterno ? "Plano de Ação" : ""} onChangeTermo={(e) => { setTitulo(e.target.value) }} onChangeSituacao={(e) => { setSituacao(e.target.value) }} acaoBtn={abrirModalNovoPlanoAcao} listaSituacao={[{ nome: 'Todos', valor: '' }, { nome: 'Pendentes', valor: 'Pendente' }, { nome: 'Iniciada', valor: 'Iniciada' }, { nome: 'Finalizada', valor: 'Finalizada' }]} genero='masculino' isLoading={processando} maisFiltros={true} acaoMaisFiltro={() => { setMaisFiltros(true) }} onSubmit={filtrarPlanoAcao} />
        {maisFiltros && <section id='maisOpcoesFiltrosTarefas'>
          <form id='maisOpcoesFiltrosTarefasContainer' onSubmit={filtrarPlanoAcao}>
            <span id='filtrosContainerTitulo'>
              <img id='filtrosAvancadosTarefas' src={maisFiltrosImg} alt='' />
              <p>Filtros Avançados</p>
            </span>
            <section id='opcoesFiltrosTarefas'>
              <section>
                <span>
                  <label htmlFor="responsaveltarefa">Responsável</label>
                  <select id='responsaveltarefa' value={responsavel} onChange={(e) => setResponsavel(e.target.value)}>
                    <option value=""></option>
                    {responsaveis.map((responsavel) => (
                      <option value={responsavel.usuario.id} key={responsavel.usuario.id}>{responsavel.usuario.nome}</option>
                    ))}
                  </select>
                </span>
              </section>
            </section>

            <span id="botoesContainerFiltrosTarefas">
              <Button type='button' cor='cancelar' isLoading={processando} onClick={() => setMaisFiltros(false)}>Cancelar</Button>
              <Button type='submit' cor='salvar' isLoading={processando}>
                {!processando && 'Buscar Dados'}
                {processando && <Loader isLoading={processando} />}
              </Button>
            </span>
          </form>
        </section>}
        {nenhumResultado && <NenhumResultadoEncontrado />}
        <section id='fundoContainerPagina'>
          <table id='tabelaListaContainer'>
            <thead>
              <tr>
                <th align='left'>Titulo</th>
                <th align='left' className='hide-responsive'>Desafio Vinculado</th>
                <th className='progressoProcesso hide-responsive' align='left'>Responsável</th>
                <th className='hide-responsive'>Previsão de Conclusão</th>
                <th align='center'>Situação</th>
              </tr>
            </thead>
            <tbody>
              {planoAcoes.map((planoAcao) => (
                <tr key={planoAcao.id} onClick={() => { setPlanoAcaoSelecionado(planoAcao); abrirModalEditarPlanoAcao() }}>
                  <td className='primeiraColuna'>{planoAcao.titulo}</td>
                  <td align='left' className='hide-responsive'>
                    {planoAcao.desafio.titulo}
                  </td>
                  <td align='center' className='hide-responsive usuarioResponsavelContentDesafios'>
                    <img src={planoAcao.usuario.avatar || avatarDefault} alt="" className="usuarioResponsavel" />
                    {planoAcao.usuario.nome}
                  </td>
                  <td align='center' className='hide-responsive'>
                    {new Date(planoAcao.dataTermino).toLocaleDateString('pt-BR')}
                  </td>
                  <td align='center' className='ladoDireitoContent'>
                    <DivSituacao texto={planoAcao.situacao} cor={planoAcao.situacao.toLocaleLowerCase()} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {modal.nome === "ModalPlanoAcao" && <ModalPlanoAcao planoAcao={planoAcaoSelecionado} />}
        </section>
      </div>
    ) : null
  );
}

export default PlanoAcao
